import { Checkbox } from "@vds/checkboxes";
import { DropdownSelect } from "@vds/selects";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InputStepperField from "../../../global/components/InputStepperField";
import {
  ConditionContainer,
  GreyText,
  InputHeaderTitle,
  OperatorAndNumberFrame,
  PeopleCountIsFrame,
  SmallText,
  TriggerFrame,
  TriggerInsideFrame
} from "../../../global/components/Modals/RoiModals/stylesRoiModal";
import NumberInput from "../../../global/components/NumberInput";
import {
  CVAPP_CAMERAADJUSTMENT,
  CVAPP_CROWDDENSITY,
  CVAPP_DWELLTIME,
  CVAPP_OBJECTBLUR,
  CVAPP_OBJECTDETECTION,
  CVAPP_OPENDOOR,
  CVAPP_PARKINGOCCUPANCYEE,
  CVAPP_PARKINGOCCUPANCYOA,
  CVAPP_PEOPLE_COUNT_EE,
  CVAPP_PEOPLE_COUNT_OA,
  CVAPP_PERSON_DETECTION,
  CVAPP_PPEUSAGE,
  CVAPP_PROXIMITY,
  CVAPP_SLIPANDFALL,
  CVAPP_UNOBJECTDETECTION,
  CVAPP_VEHICLE_DETECTION,
  CVAPP_VEHICLECOUNTEE,
  CVAPP_VEHICLECOUNTOA,
  CVAPP_WATERLEAK_DETECTION,
  eventTriggerTexts
} from "../../../global/constants/cvappConstants";
import { updateRuleValue } from "../../../store/actions";
import { useWindowSize } from "../../../global/hooks/viewportHooks";
import { CREATERULE_TEST_IDS } from "./createRuleConstants";
import { isCvAppFromInHouseVersion } from "../../../global/utility/cvAppUtils";

const Trigger = ({ EventTrigger, action, isReadOnly, result, isEditing }) => {
  const dispatch = useDispatch();
  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList) || [];

  const {
    triggerData,
    triggerActions: {
      triggerData: {
        condition,
        value,
        time,
        addCoolDownPeriod,
        coolPeriodValue,
      },
    },
    appSelected,
    colorsSelected = [],
    is_color_exclusion_set,
    enableColorAppearance: isEnableColorAppearance,
    roiColorData,
  } = useSelector((state) => state.ruleReducer);

  const { width } = useWindowSize();
  const dropdownWidth = width < 480 ? "60vw" : "37.23%";
  const numberWidth = width < 480 ? "60vw" : "20%";
  const unitWidth = width < 480 ? "60vw" : "23%";

  const [selectColors, setSelectColors] = useState(colorsSelected);
  const triggerText = eventTriggerTexts[EventTrigger];
  const [checkBoxData, setCheckBoxData] = useState([]);
  const [isColorExclusive, setIsColorExclusive] = useState(is_color_exclusion_set ?? false);
  const [enableColorAppearance, setEnableColorAppearance] = useState(isEnableColorAppearance ?? true);
  const [showCooldownForEventApps, setShowCooldownForEventApps] = useState(false);

  const updateConditionValues = (type, data) => {
    const newObj = {};
    newObj[type] = data;
    dispatch(updateRuleValue({ propName: "triggerData", value: newObj }));
  };
  const [isError, setIsError] = useState(false);

  const handleCoolDownCheckbox = () => {
    updateConditionValues("addCoolDownPeriod", !addCoolDownPeriod);
  };
  useEffect(() => {
    if (!addCoolDownPeriod) {
      updateConditionValues("coolPeriodValue", 10);
    }
  }, [addCoolDownPeriod]);
  useEffect(() => {
    if (
      EventTrigger === CVAPP_PERSON_DETECTION ||
      EventTrigger === CVAPP_VEHICLE_DETECTION ||
      EventTrigger === CVAPP_SLIPANDFALL ||
      EventTrigger === CVAPP_OPENDOOR ||
      EventTrigger === CVAPP_CAMERAADJUSTMENT ||
      EventTrigger === CVAPP_PPEUSAGE ||
      EventTrigger === CVAPP_OBJECTDETECTION ||
      EventTrigger === CVAPP_OBJECTBLUR ||
      EventTrigger === CVAPP_PROXIMITY ||
      EventTrigger === CVAPP_UNOBJECTDETECTION ||
      EventTrigger === CVAPP_WATERLEAK_DETECTION
    ) {
      //console.log("EventTrigger ", EventTrigger)
      setShowCooldownForEventApps(true);
      dispatch(
        updateRuleValue({
          propName: "triggerData",
          value: { ...triggerData, enable: true },
        })
      );
    }
  }, [dispatch]);

  const handleCheckbox = (item) => {
    setCheckBoxData((prevData) =>
      prevData.includes(item)
        ? prevData.filter((i) => i !== item)
        : [...prevData, item]
    );
  };

  useEffect(() => {
    updateConditionValues("isError", isError);
  }, [isError, setIsError]);

  useEffect(() => {
    dispatch(
      updateRuleValue([
        {
          propName: "is_color_exclusion_set",
          value: isColorExclusive,
        },
      ])
    );
  }, [isColorExclusive]);

  useEffect(() => {
  dispatch(
    updateRuleValue([
      {
        propName: "enableColorAppearance",
        value: enableColorAppearance,
      },
    ])
  );
}, [enableColorAppearance]);

  return (
    <TriggerFrame>
      {action && <InputHeaderTitle>Trigger</InputHeaderTitle>}
      <GreyText>Condition</GreyText>
      <ConditionContainer>
        {triggerText && <SmallText>{triggerText}</SmallText>}
        <TriggerInsideFrame>
          {EventTrigger === CVAPP_PARKINGOCCUPANCYEE && (
            <PeopleCountIsFrame>
              <OperatorAndNumberFrame>
                <DropdownSelect
                  id="dropdownSelect"
                  label="Operator"
                  width={dropdownWidth}
                  onChange={(e) =>
                    updateConditionValues("condition", e.target.value)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_OPERATOR_DROPDOWN}
                  readOnly={isReadOnly}
                >
                  <option value="">Select</option>
                  <option selected={"Greater than" === condition}>
                    Greater than
                  </option>
                  <option selected={"Less than" === condition}>
                    Less than
                  </option>
                </DropdownSelect>

                <NumberInput
                  id="numberInput"
                  label="Percentage (%)"
                  width={numberWidth}
                  value={value}
                  onChange={(newValue) =>
                    updateConditionValues("value", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_NUMBER_INPUT}
                  readOnly={isReadOnly}
                  error={isError}
                  isError={isError}
                  setIsError={setIsError}
                  max={100}
                  min={1}
                  appName={CVAPP_PARKINGOCCUPANCYEE}
                />
              </OperatorAndNumberFrame>
              {!isCvAppFromInHouseVersion(cvAppList, appSelected.id) && <><Checkbox
                name="default"
                width="auto"
                label="Enable cool down period "
                disabled={isReadOnly}
                error={false}
                onChange={handleCoolDownCheckbox}
                data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_CHECKBOX}
                selected={addCoolDownPeriod}
              ></Checkbox>
              {addCoolDownPeriod && (
                <InputStepperField
                  label={"Cool down period (min.)"}
                  value={coolPeriodValue}
                  onChange={(newValue) =>
                    updateConditionValues("coolPeriodValue", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_NUMBER_INPUT}
                  minValue={1}
                  maxValue={43201} // 30 days in minutes
                  readOnly={isReadOnly}
                />
              )}</>}
            </PeopleCountIsFrame>
          )}
          {EventTrigger === CVAPP_PARKINGOCCUPANCYOA && (
            <PeopleCountIsFrame>
              <OperatorAndNumberFrame>
                <DropdownSelect
                  label="Operator"
                  width={dropdownWidth}
                  onChange={(e) =>
                    updateConditionValues("condition", e.target.value)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_OPERATOR_DROPDOWN}
                  readOnly={isReadOnly}
                >
                  <option value="">Select</option>
                  <option selected={"Greater than" === condition}>
                    Greater than
                  </option>
                  <option selected={"Less than" === condition}>
                    Less than
                  </option>
                </DropdownSelect>

                <NumberInput
                  width={numberWidth}
                  label="Percentage (%)"
                  value={value}
                  onChange={(newValue) =>
                    updateConditionValues("value", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_NUMBER_INPUT}
                  readOnly={isReadOnly}
                  error={isError}
                  isError={isError}
                  setIsError={setIsError}
                  max={100}
                  min={1}
                  appName={CVAPP_PARKINGOCCUPANCYOA}
                />
              </OperatorAndNumberFrame>
               {!isCvAppFromInHouseVersion(cvAppList, appSelected.id) && <><Checkbox
                name="default"
                width="auto"
                label="Enable cool down period "
                disabled={isReadOnly}
                error={false}
                onChange={handleCoolDownCheckbox}
                data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_CHECKBOX}
                selected={addCoolDownPeriod}
              ></Checkbox>
              {addCoolDownPeriod && (
                <InputStepperField
                  label={"Cool down period (min.)"}
                  value={coolPeriodValue}
                  onChange={(newValue) =>
                    updateConditionValues("coolPeriodValue", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_NUMBER_INPUT}
                  minValue={1}
                  maxValue={43201} // 30 days in minutes
                  readOnly={isReadOnly}
                />
              )}</>}
            </PeopleCountIsFrame>
          )}
          {EventTrigger === CVAPP_DWELLTIME && (
            <PeopleCountIsFrame>
              <OperatorAndNumberFrame>
                <DropdownSelect
                  label="Operator"
                  width={dropdownWidth}
                  onChange={(e) =>
                    updateConditionValues("condition", e.target.value)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_OPERATOR_DROPDOWN}
                  readOnly={isReadOnly}
                >
                  <option value="">Select</option>
                  <option selected={"Greater than" === condition}>
                    Greater than
                  </option>
                  <option selected={"Less than" === condition}>
                    Less than
                  </option>
                </DropdownSelect>

                <NumberInput
                  width={numberWidth}
                  label="Number"
                  value={value}
                  onChange={(newValue) =>
                    updateConditionValues("value", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_NUMBER_INPUT}
                  readOnly={isReadOnly}
                  error={isError}
                  isError={isError}
                  setIsError={setIsError}
                  min={1}
                  appName={CVAPP_DWELLTIME}
                />
                <DropdownSelect
                  label="Unit"
                  width={unitWidth}
                  onChange={(e) =>
                    updateConditionValues("time", e.target.value)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_UNIT_DROPDOWN}
                  readOnly={isReadOnly}
                >
                  <option value="">Select</option>
                  <option selected={"seconds" === time}>seconds</option>
                  <option selected={"minutes" === time}>minutes</option>
                  <option selected={"hours" === time}>hours</option>
                </DropdownSelect>
              </OperatorAndNumberFrame>
              {!isCvAppFromInHouseVersion(cvAppList, appSelected.id) && <><Checkbox
                name="default"
                width="auto"
                label="Enable cool down period "
                disabled={isReadOnly}
                error={false}
                onChange={handleCoolDownCheckbox}
                data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_CHECKBOX}
                selected={addCoolDownPeriod}
              ></Checkbox>
              {addCoolDownPeriod && (
                <InputStepperField
                  label={"Cool down period (min.)"}
                  value={coolPeriodValue}
                  onChange={(newValue) =>
                    updateConditionValues("coolPeriodValue", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_NUMBER_INPUT}
                  minValue={1}
                  maxValue={43201} // 30 days in minutes
                  readOnly={isReadOnly}
                />
              )}</>}
            </PeopleCountIsFrame>
          )}
          {EventTrigger === CVAPP_PEOPLE_COUNT_OA && (
            <PeopleCountIsFrame>
              <OperatorAndNumberFrame>
                <DropdownSelect
                  label="Operator"
                  width={dropdownWidth}
                  onChange={(e) =>
                    updateConditionValues("condition", e.target.value)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_OPERATOR_DROPDOWN}
                  readOnly={isReadOnly}
                >
                  <option value="">Select</option>
                  <option selected={"Greater than" === condition}>
                    Greater than
                  </option>
                  <option selected={"Less than" === condition}>
                    Less than
                  </option>
                </DropdownSelect>

                <NumberInput
                  width={numberWidth}
                  label="Number"
                  value={value}
                  onChange={(newValue) =>
                    updateConditionValues("value", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_NUMBER_INPUT}
                  readOnly={isReadOnly}
                  error={isError}
                  isError={isError}
                  setIsError={setIsError}
                />
              </OperatorAndNumberFrame>
              {!isCvAppFromInHouseVersion(cvAppList, appSelected.id) && <><Checkbox
                name="default"
                width="auto"
                label="Enable cool down period "
                disabled={isReadOnly}
                error={false}
                onChange={handleCoolDownCheckbox}
                data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_CHECKBOX}
                selected={addCoolDownPeriod}
              ></Checkbox>
              {addCoolDownPeriod && (
                <InputStepperField
                  label={"Cool down period (min.)"}
                  value={coolPeriodValue}
                  onChange={(newValue) =>
                    updateConditionValues("coolPeriodValue", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_NUMBER_INPUT}
                  minValue={1}
                  maxValue={43201} // 30 days in minutes
                  readOnly={isReadOnly}
                />
              )}</>}
            </PeopleCountIsFrame>
          )}
          {EventTrigger === CVAPP_PEOPLE_COUNT_EE && (
            <PeopleCountIsFrame>
              <OperatorAndNumberFrame>
                <DropdownSelect
                  label="Operator"
                  width={dropdownWidth}
                  onChange={(e) =>
                    updateConditionValues("condition", e.target.value)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_OPERATOR_DROPDOWN}
                  readOnly={isReadOnly}
                >
                  <option value="">Select</option>
                  <option selected={"Greater than" === condition}>
                    Greater than
                  </option>
                  <option selected={"Less than" === condition}>
                    Less than
                  </option>
                </DropdownSelect>

                <NumberInput
                  width={numberWidth}
                  label="Number"
                  value={value}
                  onChange={(newValue) =>
                    updateConditionValues("value", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_NUMBER_INPUT}
                  readOnly={isReadOnly}
                  error={isError}
                  isError={isError}
                  setIsError={setIsError}
                />
              </OperatorAndNumberFrame>
              {!isCvAppFromInHouseVersion(cvAppList, appSelected.id) && <><Checkbox
                name="default"
                width="auto"
                label="Enable cool down period "
                disabled={isReadOnly}
                error={false}
                onChange={handleCoolDownCheckbox}
                data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_CHECKBOX}
                selected={addCoolDownPeriod}
              ></Checkbox>
              {addCoolDownPeriod && (
                <InputStepperField
                  label={"Cool down period (min.)"}
                  value={coolPeriodValue}
                  onChange={(newValue) =>
                    updateConditionValues("coolPeriodValue", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_NUMBER_INPUT}
                  minValue={1}
                  maxValue={43201} // 30 days in minutes
                  readOnly={isReadOnly}
                />
              )}</>}
            </PeopleCountIsFrame>
          )}
          {EventTrigger === CVAPP_VEHICLECOUNTOA && (
            <PeopleCountIsFrame>
              <OperatorAndNumberFrame>
                <DropdownSelect
                  label="Operator"
                  width={dropdownWidth}
                  onChange={(e) =>
                    updateConditionValues("condition", e.target.value)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_OPERATOR_DROPDOWN}
                  readOnly={isReadOnly}
                >
                  <option value="">Select</option>
                  <option selected={"Greater than" === condition}>
                    Greater than
                  </option>
                  <option selected={"Less than" === condition}>
                    Less than
                  </option>
                </DropdownSelect>

                <NumberInput
                  width={numberWidth}
                  label="Number"
                  value={value}
                  onChange={(newValue) =>
                    updateConditionValues("value", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_NUMBER_INPUT}
                  readOnly={isReadOnly}
                  error={isError}
                  isError={isError}
                  setIsError={setIsError}
                />
              </OperatorAndNumberFrame>
              {!isCvAppFromInHouseVersion(cvAppList, appSelected.id) && <><Checkbox
                name="default"
                width="auto"
                label="Enable cool down period "
                disabled={isReadOnly}
                error={false}
                onChange={handleCoolDownCheckbox}
                data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_CHECKBOX}
                selected={addCoolDownPeriod}
              ></Checkbox>
              {addCoolDownPeriod && (
                <InputStepperField
                  label={"Cool down period (min.)"}
                  value={coolPeriodValue}
                  onChange={(newValue) =>
                    updateConditionValues("coolPeriodValue", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_NUMBER_INPUT}
                  minValue={1}
                  maxValue={43201} // 30 days in minutes
                  readOnly={isReadOnly}
                />
              )}</>}
            </PeopleCountIsFrame>
          )}
          {EventTrigger === CVAPP_VEHICLECOUNTEE && (
            <PeopleCountIsFrame>
              <OperatorAndNumberFrame>
                <DropdownSelect
                  label="Operator"
                  width={dropdownWidth}
                  onChange={(e) =>
                    updateConditionValues("condition", e.target.value)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_OPERATOR_DROPDOWN}
                  readOnly={isReadOnly}
                >
                  <option value="">Select</option>
                  <option selected={"Greater than" === condition}>
                    Greater than
                  </option>
                  <option selected={"Less than" === condition}>
                    Less than
                  </option>
                </DropdownSelect>

                <NumberInput
                  width={numberWidth}
                  label="Number"
                  value={value}
                  onChange={(newValue) =>
                    updateConditionValues("value", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_NUMBER_INPUT}
                  readOnly={isReadOnly}
                  error={isError}
                  isError={isError}
                  setIsError={setIsError}
                />
              </OperatorAndNumberFrame>
              {!isCvAppFromInHouseVersion(cvAppList, appSelected.id) && <><Checkbox
                name="default"
                width="auto"
                label="Enable cool down period "
                disabled={isReadOnly}
                error={false}
                onChange={handleCoolDownCheckbox}
                data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_CHECKBOX}
                selected={addCoolDownPeriod}
              ></Checkbox>
              {addCoolDownPeriod && (
                <InputStepperField
                  label={"Cool down period (min.)"}
                  value={coolPeriodValue}
                  onChange={(newValue) =>
                    updateConditionValues("coolPeriodValue", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_NUMBER_INPUT}
                  minValue={1}
                  maxValue={43201} // 30 days in minutes
                  readOnly={isReadOnly}
                />
              )}</>}
            </PeopleCountIsFrame>
          )}
          {EventTrigger === CVAPP_CROWDDENSITY && (
            <PeopleCountIsFrame>
              <OperatorAndNumberFrame>
                <DropdownSelect
                  label="Operator"
                  width={dropdownWidth}
                  onChange={(e) =>
                    updateConditionValues("condition", e.target.value)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_OPERATOR_DROPDOWN}
                  readOnly={isReadOnly}
                >
                  <option value="">Select</option>
                  <option selected={"Greater than" === condition}>
                    Greater than
                  </option>
                  <option selected={"Less than" === condition}>
                    Less than
                  </option>
                </DropdownSelect>

                <NumberInput
                  width={numberWidth}
                  label="Number"
                  value={value}
                  onChange={(newValue) =>
                    updateConditionValues("value", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_NUMBER_INPUT}
                  readOnly={isReadOnly}
                  error={isError}
                  isError={isError}
                  setIsError={setIsError}
                />
              </OperatorAndNumberFrame>
              {!isCvAppFromInHouseVersion(cvAppList, appSelected.id) && <><Checkbox
                name="default"
                width="auto"
                label="Enable cool down period "
                disabled={isReadOnly}
                error={false}
                onChange={handleCoolDownCheckbox}
                data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_CHECKBOX}
                selected={addCoolDownPeriod}
              ></Checkbox>
              {addCoolDownPeriod && (
                <InputStepperField
                  label={"Cool down period (min.)"}
                  value={coolPeriodValue}
                  onChange={(newValue) =>
                    updateConditionValues("coolPeriodValue", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_NUMBER_INPUT}
                  minValue={1}
                  maxValue={43201} // 30 days in minutes
                  readOnly={isReadOnly}
                />
              )}</>}
            </PeopleCountIsFrame>
          )}
          {
            showCooldownForEventApps && (
              <PeopleCountIsFrame>
                {!isCvAppFromInHouseVersion(cvAppList, appSelected.id) && <><Checkbox
                  name="default"
                  width="auto"
                  label="Enable cool down period "
                  disabled={isReadOnly}
                  error={false}
                  onChange={handleCoolDownCheckbox}
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_CHECKBOX}
                  selected={addCoolDownPeriod}
                ></Checkbox>
              {addCoolDownPeriod && (
                <InputStepperField
                  label={"Cool down period (sec.)"}
                  unitoftime="seconds"
                  value={coolPeriodValue}
                  onChange={(newValue) =>
                    updateConditionValues("coolPeriodValue", newValue)
                  }
                  data-testid={CREATERULE_TEST_IDS.TRIGGER_COOLDOWN_NUMBER_INPUT}
                  minValue={10}
                  maxValue={43201} 
                  readOnly={isReadOnly}
                />
              )}</>}
            </PeopleCountIsFrame>
            )
          }
        </TriggerInsideFrame>
      </ConditionContainer>
    </TriggerFrame>
  );
};

export default Trigger;
